// Kept out of the registry so the navbar can offer a page's tour without
// loading every tour's steps up front. Keyed by route name.
export const PAGE_TOUR_KEYS: Record<string, string> = {
  home: "page-home",
  "dashboard-overview": "page-dashboards",
  "view-dashboard": "page-dashboard",
  "goals-overview": "page-goals",
  "all-recommendations": "page-recommendations",
  "ad-performance-overview": "page-ad-performance",
  "marketing-performance-ads": "page-marketing-performance",
  resources: "page-resources",
  general: "page-organization-settings",
  profile: "page-profile",
  "mcp-applications": "page-mcp",
  hub: "page-hub",
  "select-channel": "page-connect",
  "utm-builder": "page-utm-builder",
  tags: "page-tags",
  organization_settings_automations: "page-automations",
  "calculated-metrics": "page-calculated-metrics",
  "edit-conversions": "page-conversions",
  budget_tool: "page-budget",
  "social-media-account-summary": "page-social-media",
  "website-analytics-acquisition-tab": "page-website-analytics",
  competitors: "page-competitors",
  "share-of-search": "page-share-of-search",
  "site-score": "page-site-score",
  ai_visibility_overview: "page-ai-visibility",
  ai_visibility_prompts: "page-ai-visibility-prompts",
};
